<div *ngIf="cargado===false">
  <div class="input-group mb-3">
    <span class="input-group-text" id="inputGroup-sizing-default">Email</span>
    <input id="Email" [(ngModel)]="cliente.email" type="text" class="form-control"
      aria-label="Email" aria-describedby="inputGroup-sizing-default">
  </div>
  <div class="input-group mb-3">
    <span class="input-group-text" id="inputGroup-sizing-default">Contraseña</span>
    <input id="password" [(ngModel)]="cliente.password" type="password" class="form-control"
      aria-label="password" aria-describedby="inputGroup-sizing-default">
  </div>
  <div class="input-group mb-3">
    <span class="input-group-text" id="inputGroup-sizing-default">DNI</span>
    <input id="dni" [(ngModel)]="cliente.dni" type="number" class="form-control"
      aria-label="dni" aria-describedby="inputGroup-sizing-default">
  </div>
  <div class="input-group mb-3">
    <span class="input-group-text" id="inputGroup-sizing-default">Nombre y Apellido</span>
    <input id="nombreApellido" [(ngModel)]="cliente.nombres" type="text" class="form-control"
      aria-label="nombreApellido" aria-describedby="inputGroup-sizing-default">
  </div>
  <div><button class="btn btn-primary" type="button" (click)="cargar()">Enviar</button></div>



</div>

<div *ngIf="cargado===true">
  <div class="d-flex justify-content-center">
    <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" fill="currentColor" class="bi bi-check-lg" viewBox="0 0 16 16">
    <path d="M13.485 1.431a1.473 1.473 0 0 1 2.104 2.062l-7.84 9.801a1.473 1.473 0 0 1-2.12.04L.431 8.138a1.473 1.473 0 0 1 2.084-2.083l4.111 4.112 6.82-8.69a.486.486 0 0 1 .04-.045z"/>
  </svg> </div>
  <div class="d-flex justify-content-center"> <p class="h1">Tu usuario fue creado, se te envio un mail para activarlo</p></div>
</div>
